import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const StatCards = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium text-gray-600">Total Boxes</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-gray-800" data-testid="stat-total">{stats.total}</div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium text-gray-600">Active</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-green-600" data-testid="stat-active">{stats.active}</div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium text-gray-600">Inactive</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-gray-500" data-testid="stat-inactive">{stats.inactive}</div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium text-gray-600">Vendors</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-purple-600" data-testid="stat-vendors">{stats.vendors}</div>
        </CardContent>
      </Card>
    </div>
  );
};

export default StatCards;
